import { NotificationsRepository } from '../repositories/notifications.repository'
import {
    CreateBlacklistRecordPayload,
    ExportExcelChatParams,
    ExportExcelParams,
    ExportExcelResponse,
    GetBlacklistParams,
    GetBlacklistResponse,
    GetWhatsappChatMessagesParams,
    GetWhatsappChatMessagesResponse,
    GetWhatsappChatsParams,
    GetWhatsappChatsResponse,
    NotificationPayloadT,
    NotificationsGetListResponseT,
    NotificationsGetTypesResponseT,
} from '../types/notifications.types'

const notificationsRepository = new NotificationsRepository()

export class NotificationsService {
    async getNotificationsList(params: any): Promise<NotificationsGetListResponseT> {
        const response = await notificationsRepository.getNotificationsList(params)
        return response.data
    }

    async createNotification(payload: NotificationPayloadT): Promise<void> {
        const response = await notificationsRepository.createNotification(payload)
        return response.data
    }

    async getNotificationsTypes(params: any): Promise<NotificationsGetTypesResponseT> {
        const response = await notificationsRepository.getNotificationsTypes(params)
        return response.data
    }

    async setDeviceToken(token: string): Promise<void> {
        const response = await notificationsRepository.setDeviceToken(token)
        return response.data
    }

    async readNotification(notification_id: number | string): Promise<void> {
        const response = await notificationsRepository.readNotification(notification_id)
        return response.data
    }

    async getWhatsappChats(params: GetWhatsappChatsParams): Promise<GetWhatsappChatsResponse> {
        const response = await notificationsRepository.getWhatsappChats(params)
        return response.data
    }

    async getWhatsappChatMessages(
        params: GetWhatsappChatMessagesParams
    ): Promise<GetWhatsappChatMessagesResponse> {
        const response = await notificationsRepository.getWhatsappChatMessages(params)
        return response.data
    }

    async exportExcel(params: ExportExcelParams): Promise<ExportExcelResponse> {
        const response = await notificationsRepository.exportExcel(params)
        return response.data
    }

    async exportExcelChat(params: ExportExcelChatParams): Promise<ExportExcelResponse> {
        const response = await notificationsRepository.exportExcelChat(params)
        return response.data
    }

    async getBlacklist(params: GetBlacklistParams): Promise<GetBlacklistResponse> {
        const response = await notificationsRepository.getBlacklist(params)
        return response.data
    }

    async createBlacklistRecord(payload: CreateBlacklistRecordPayload): Promise<void> {
        const response = await notificationsRepository.createBlacklistRecord(payload)
        return response.data
    }

    async deleteBlacklistRecord(recordId: number): Promise<void> {
        const response = await notificationsRepository.deleteBlacklistRecord(recordId)
        return response.data
    }
}
